export const UPDATE_TIER_DESCRIPTION = "UPDATE_TIER_DESCRIPTION";
export const CREATE_TIER_DESCRIPTION = "CREATE_TIER_DESCRIPTION";
export const DELETE_TIER_DESCRIPTION = "DELETE_TIER_DESCRIPTION";
